var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"dialog-box",class:_vm.styleMessage},[_c('i',{class:_vm.styleMessage === 'danger' ? 'fas fa-times-circle' : 'fas fa-check-circle'}),_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"btn-modal",on:{"click":function($event){return _vm.CHANGE_MESSAGE_MODAL({
            show:false,
            title: '',
            message: '',
            styleMessage: 'danger'
        })}}},[_vm._v(" Entendi ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }